export const assortmentImages = {
    main: [
        {
            imageKey: "src/assets/images/sortiment/geschenke.jpg",
            alt: "Maritime Geschenkartikel im Hooksieler Lädchen",
            label: "Geschenke",
        },
        {
            imageKey: "src/assets/images/sortiment/mode.jpg",
            alt: "Mode und Outdoorbekleidung im Hooksieler Lädchen",
            label: "Mode",
        },
        {
            imageKey: "src/assets/images/sortiment/teesortiment.jpg",
            alt: "Teesortiment im Hooksieler Lädchen",
            label: "Tee",
        },
    ],
    fashion: [
        {
            imageKey: "src/assets/images/sortiment/more.jpg",
            alt: "Mode und Accessoires von More & More",
            label: "Kollektionen",
        },
        {
            imageKey: "src/assets/images/sortiment/jacke.jpg",
            alt: "Lederjacke und Mode im Hooksieler Lädchen",
            label: "Lederjacken",
        },
        {
            imageKey: "src/assets/images/sortiment/hemd.jpg",
            alt: "Maritime Hemden im Hooksieler Lädchen",
            label: "Maritim",
        },
    ],
    belts: [
        {
            imageKey: "src/assets/images/sortiment/schnalle1.jpg",
            alt: "Oranger Ledergürtel mit Wechselschließe",
        },
        {
            imageKey: "src/assets/images/sortiment/schnalle2.jpg",
            alt: "Roter Ledergürtel mit Wechselschließe",
        },
        {
            imageKey: "src/assets/images/sortiment/schnalle3.jpg",
            alt: "Gelber Ledergürtel mit Wechselschließe",
        },
    ],
};

export const assortmentHighlights = [
    "Mode von comma, CASUAL IDENTITY und More & More",
    "Funktionelle Outdoorbekleidung und Friesennerz",
    "Gummistiefel, Flip-Flops, Wattschuhe und Moccasins",
    "Ledergürtel mit individuellen Wechselschließen",
    "Lederjacken für Sie und Ihn",
    "Fischerhemden und maritime Kleidung für Groß und Klein",
    "79 verschiedene Teesorten",
    "Maritime Souvenir- und Geschenkartikel",
];